exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item-title[data-v-3fb42540]{font-size:16px;font-weight:500;margin:10px 0}.optional-tip[data-v-3fb42540]{font-size:12px;font-weight:400;color:#999}.el-input[data-v-3fb42540],.el-select[data-v-3fb42540]{width:200px}.campus-select[data-v-3fb42540]{width:460px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3fb42540&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/JuTuiAdShield.vue
// module id = 503
// module chunks = 0